import { render } from "./Inovda.vue?vue&type=template&id=79997720"
import script from "./Inovda.vue?vue&type=script&lang=js"
export * from "./Inovda.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__